import {
  clearSessionState,
  setSession,
} from '@/core/auth/session/session.store'
import {
  clearPersistedSession,
  loadPersistedSession,
  persistSession,
  getStoredToken,
} from '@/core/auth/session/session.storage'
import type {
  SessionLifecycleHandler,
  UserProfile,
} from '@/core/auth/session/session.types'
import { setMonitoringUser } from '@/core/monitoring/sentry'

let unauthorizedHandler: SessionLifecycleHandler | null = null

export const sessionService = {
  hydrateSession() {
    const stored = loadPersistedSession()

    if (!stored) {
      clearSessionState()
      setMonitoringUser(null)
      return
    }

    setSession(stored.profile, stored.expiresAtUtc)
    setMonitoringUser(stored.profile)
  },

  startSession(profile: UserProfile, expiresAtUtc: string, accessToken?: string) {
    const token = accessToken ?? getStoredToken() ?? ''
    persistSession({ profile, expiresAtUtc, accessToken: token })
    setSession(profile, expiresAtUtc)
    setMonitoringUser(profile)
  },

  clearSession() {
    clearPersistedSession()
    clearSessionState()
    setMonitoringUser(null)
  },

  async handleUnauthorized() {
    this.clearSession()

    if (unauthorizedHandler) {
      await unauthorizedHandler()
    }
  },

  registerUnauthorizedHandler(handler: SessionLifecycleHandler) {
    unauthorizedHandler = handler
  },
}
